import 'pages/Dashboard/assets/Dashboard.css';
import React from 'react';
import { useCreateRoleMutation } from 'services/roles/roles.api';
import RolePage from '../RoleManager';

const CREATE_ROLE_FORM_KEY = 'fusionCreateRoleForm';
const CREATE_ROLE_MEMBER_KEY = 'fusionCreateRoleMembers';
const CREATE_ROLE_TAB_KEY = 'fusionCreateRoleTab';

const TAB_OPTIONS = ['Role Details', 'Permissions', 'Dashboard Edit', 'Dashboard View'];

export default function CreateRole(): JSX.Element {
  type RoleSubmitPayload = {
    roleName: string;
    members: number[];
    permissions: string;
    layout: string;
    roleId?: string | number;
  };

  const [createRoleTrigger] = useCreateRoleMutation();
  const mutate = (payload: RoleSubmitPayload) => createRoleTrigger(payload).unwrap();
  const tabHeaderOptions = TAB_OPTIONS.map((option) => ({ option }));

  return (
    <RolePage
      mode="create"
      mutate={mutate}
      enableLocalStorage={true}
      localStorageKeys={{
        formKey: CREATE_ROLE_FORM_KEY,
        memberKey: CREATE_ROLE_MEMBER_KEY,
        tabKey: CREATE_ROLE_TAB_KEY,
      }}
      tabOptions={TAB_OPTIONS}
      tabHeaderOptions={tabHeaderOptions}
      validatePermissionsOnMount={['CreateRole']}
    />
  );
}
